module.exports = __webpack_public_path__ + "img/jimeng.17de8d16.png";